module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "140px"
    }
  }, [_vm._l((_vm.list), function(member, index) {
    return _c('div', {
      key: index
    }, [_c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "姓名:",
        "prop": "name"
      }
    }, [_c('span', [_vm._v(_vm._s(member.name))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "性别:",
        "prop": "sex"
      }
    }, [_c('span', [_vm._v(_vm._s(member.sex))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "身份证号:",
        "prop": "num"
      }
    }, [_c('span', [_vm._v(_vm._s(member.num))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "联系电话:",
        "prop": "phone"
      }
    }, [_c('span', [_vm._v(_vm._s(member.phone))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "微信:",
        "prop": "weixin"
      }
    }, [_c('span', [_vm._v(_vm._s(member.weixin))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [(_vm.row.memberstatus == 6) ? _c('el-form-item', {
      attrs: {
        "label": "申报项目:",
        "prop": "project"
      }
    }, [_c('span', [_vm._v(_vm._s(member.project))])]) : _c('el-form-item', {
      attrs: {
        "label": "选择项目",
        "prop": "oldgrade"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (member.project),
        callback: function($$v) {
          _vm.$set(member, "project", $$v)
        },
        expression: "member.project"
      }
    }, _vm._l((_vm.projectColumns), function(item) {
      return _c('el-radio', {
        key: item,
        attrs: {
          "label": item
        }
      }, [_vm._v(_vm._s(item))])
    }), 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), (_vm.row.memberstatus != 6) ? _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("确认报名\n          ")])], 1)], 1) : _vm._e()], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f81b119","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/skill/AbilityApplyMemberService.vue
// module id = 1325
// module chunks = 0